import { useMemo } from "react";
import { CircularProgressBar } from "@tomik23/react-circular-progress-bar";
import "react-rangeslider/lib/index.css";

import { renderClassName, resolveRiskValue } from "./utils/stakingRiskHelpers";
import { formatStakingCurrency } from "../../Utils/helper";

export function StakingRiskCardExistingShort({ element, id }) {
  const safetyIndex = resolveRiskValue(element?.stakingRisk?.safetyIndex);
  const riskColor =
    safetyIndex >= 65
      ? "green"
      : safetyIndex >= 31
        ? "yellow"
        : safetyIndex > 0
          ? "red"
          : "white";
  const cardConfig = useMemo(
    () => renderClassName(safetyIndex, riskColor, 56),
    [safetyIndex, riskColor],
  );

  return (
    <div
      className={cardConfig?.className || ""}
      style={{
        padding: "14px 3px",
        height: "75px",
        display: "flex",
        alignItems: "self-start",
      }}
    >
      <div className="card__list__percent" style={{ marginLeft: "5px" }}></div>
      <div className="card__list__content" style={{ lineHeight: "15px" }}>
        <h3 className="card__list__title">
          {element.assetId?.symbol} {element?.stakingRisk?.name}
        </h3>
        <span style={{ fontSize: "12px" }}>
          {" "}
          Staked Amount
          <br />
          {formatStakingCurrency(element?.stakedAmount)}
        </span>
        <div className="card__risk__chart__list" style={{ top: "-3px" }}>
          <CircularProgressBar {...(cardConfig?.props || {})}>
            <div className="card__round__shadow__defi__list"></div>
            <div
              className="card__risk__chart__min__wrapper"
              style={{ top: "50%", right: "-50px" }}
            >
              <p
                className="card__risk__chart__number"
                style={{
                  color: renderClassName(element?.stakingRisk?.safetyIndex)
                    ?.color,
                }}
              >
                {" "}
                {safetyIndex}{" "}
              </p>
            </div>
          </CircularProgressBar>
        </div>
      </div>
    </div>
  );
}
